import { officeDarkTheme, schoolDarkTheme, quizDarkTheme } from "../../themes";


export const calcStarterTheme = (product) => {

    switch (product?.id) {
        case 1:
        default:
            return schoolDarkTheme
        case 2:
            return officeDarkTheme
        case 4:
            return quizDarkTheme
    }
}